export default class Security {
  access(usuario, modulo) {
    switch (usuario.nivel) {
      case "administrador":
        return true;
      case "inspecao":
        return this.getInspecaoAcesso(modulo);
      case "compra":
        return this.getCompraAcesso(modulo);
      case "transporte":
        return this.getTransporteAcesso(modulo);
      case "almoxarifado":
        return this.getAlmoxarifadoAcesso(modulo);
      case "mobile":
        return this.getMobileAcesso(modulo);
    }
  }

  getInspecaoAcesso(modulo) {
    switch (modulo) {
      case "CLIENTE":
        return true;
      case "IMAGEM":
        return true;
      case "EQUIPAMENTO":
        return true;
      case "INSPECAO":
        return true;
      case "RELATORIO":
        return true;
      case "SERVICO":
        return true;
      default:
        return false;
    }
  }

  getCompraAcesso(modulo) {
    switch (modulo) {
      case "CLIENTE":
        return true;
      case "COMPRA":
        return true;
      case "ARMAZEM":
        return true;
      default:
        return false;
    }
  }

  getTransporteAcesso(modulo) {
    switch (modulo) {
      case "TRANSPORTE":
        return true;
      default:
        return false;
    }
  }

  getAlmoxarifadoAcesso(modulo) {
    switch (modulo) {
      case "CLIENTE":
        return true;
      case "ARMAZEM":
        return true;
      default:
        return false;
    }
  }

  getMobileAcesso(modulo) {
    switch (modulo) {
      case "CLIENTE":
        return true;
      case "EQUIPAMENTO":
        return true;
      default:
        return false;
    }
  }
}
